import { useMutation } from "@apollo/client";
import { Button } from "components/core";
import { FC } from "react";
import toast from "react-hot-toast";
import { RETRY_PREPAID_SYNC } from "apollo/prepaid-syncs";

interface PrepaidSyncRetryButtonProps {
  prepaidSyncId?: string;
  status?: string;
  onCompleted?: () => void;
  className?: string;
}

export const PrepaidSyncRetryButton: FC<PrepaidSyncRetryButtonProps> = ({
  prepaidSyncId,
  status,
  onCompleted,
  className = "w-auto",
}) => {
  const [retryPrepaidSync, { loading }] = useMutation(RETRY_PREPAID_SYNC, {
    onCompleted: () => {
      onCompleted?.();
      toast(
        JSON.stringify({
          type: "success",
          title: "Sync queued successfully",
        }),
      );
    },
    onError: () => {
      toast(
        JSON.stringify({
          type: "error",
          title: "Could not retry sync",
        }),
      );
    },
  });

  if (!prepaidSyncId || status === "Completed") {
    return null;
  }

  return (
    <Button
      type="button"
      theme="primary"
      disabled={loading}
      className={className}
      onClick={() => {
        void retryPrepaidSync({ variables: { id: prepaidSyncId } });
      }}
    >
      {loading ? "Retrying..." : "Retry"}
    </Button>
  );
};

export default PrepaidSyncRetryButton;
